module.exports = __webpack_public_path__ + "static/media/bg-application.0d2acdad.jpg";